import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Excellens';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const BASE_URL = env.ENDPOINT_URL
export const DOMAIN = env.DOMAIN
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/log-in';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/panel/default`;
export const UNAUTHENTICATED_ENTRY = '/log-in'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'es',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};